// @flow
// import {TechnicalService} from 'modules/common/components/Alert';
import {Header} from 'modules/common/components/Header';
import {PageContent} from 'modules/common/components/PageContent';
// import {NOTIFICATION_PROPS} from 'modules/common/constants';
import {useSwitchState} from 'modules/common/hooks/use-switch-state';
import type {TNotification} from 'modules/common/types';
import React from 'react';
// import {useEffectOnce} from 'react-use';
// import React, {useEffect} from 'react';
// import {useToasts} from 'react-toast-notifications';

type TProps = {
    children: React$Node,
};

/**
 * Лейаут с шапкой и навигационным меню
 * @returns React-компонент
 */
export const Layout = ({children}: TProps) => {
    // const {addToast} = useToasts();
    const [showMenu, {toggle: toggleMenu}] = useSwitchState(false);
    // const [tsIsOpened, {toggle: tsHandleClick}] = useSwitchState(false);

    const notificationList: TNotification[] = [
        {
            date: '2020-05-07 21:15:30',
            id: 1,
            isNew: true,
            text: 'Пользователь {b}Greg Howard{/b} приглашен в компанию',
            type: 'success',
        },
        {
            date: '2020-05-07 21:15:30',
            id: 2,
            isNew: false,
            text: 'Не удалось завершить операцию. Проверьте интернет соединение',
            type: 'error',
        },
    ];

    // const newNotificationList = notificationList.filter((notification) => notification.isNew);

    /* useEffect(() => {
        if (newNotificationList) {
            newNotificationList.forEach((newNotification) => {
                let before = newNotification.text.split('{b}')[0];
                let current = newNotification.text.split('{b}')[1].split('{/b}')[0];
                let after = newNotification.text.split('{/b}')[1];

                addToast(
                    <div>
                        {before}
                        <strong>{current}</strong>
                        {after}
                    </div>,
                    NOTIFICATION_PROPS[newNotification.type]
                );
            });
        }
    }, []);*/

    // useEffectOnce(() => {
    //     setTimeout(() => {
    //         tsHandleClick(true);
    //     }, 1000);
    // }, [tsHandleClick]);

    return (
        <>
            <Header notificationList={notificationList} onShow={toggleMenu} showMenu={showMenu} />
            <PageContent closeMenu={toggleMenu} showMenu={showMenu}>
                {children}
                {/* <TechnicalService isOpen={tsIsOpened} onClose={tsHandleClick} /> */}
            </PageContent>
        </>
    );
};
